import { useMemo } from "react";
import { useSelector } from "react-redux";
import { PROXY_TYPES } from "../../../../../../utils/constants";
import { useIsThemeDark } from "../../../../../../hooks/useIsThemeDark";
import Animation from "../../../../../../components/ui/Animation/Animation";
// import ipv4Dark from "./IPv4_dark.svg";
// import ipv4Light from "./IPv4_light.svg";
// import ipv4CountryDark from "./Country_dark.svg";
// import ipv4CountryLight from "./Country_light.svg";
// import ipv6Dark from "./IPv6_dark.svg";
// import ipv6Light from "./IPv6_light.svg";
// import ispDark from "./ISP_dark.svg";
// import ispLight from "./ISP_light.svg";
// import mobileDark from "./Mobile_dark.png";
// import mobileLight from "./Mobile_light.svg";

// const Animation = lazy(() => import("../../../../../../components/ui/Animation/Animation"));

export const IndexAnimation = () => {
  // const [isAnimationVisible, setIsAnimationVisible] = useState(false);
  // const [isStaticAnimationVisible, setIsStaticAnimationVisible] = useState(false);

  const { activeData } = useSelector((state) => state.content);
  const isThemeDark = useIsThemeDark();
  const countryCode = activeData?.country?.code;

  const themePrefix = isThemeDark ? "dark" : "light";

  const isIpv4Country = countryCode && activeData?.proxy?.code === PROXY_TYPES.ipv4.code;

  // const images = {
  //   "IPv4_dark": ipv4Dark,
  //   "IPv4_light": ipv4Light,
  //   "Country_dark": ipv4CountryDark,
  //   "Country_light": ipv4CountryLight,
  //   "IPv6_dark": ipv6Dark,
  //   "IPv6_light": ipv6Light,
  //   "ISP_dark": ispDark,
  //   "ISP_light": ispLight,
  //   "Mobile_dark": mobileDark,
  //   "Mobile_light": mobileLight
  // };

  // useEffect(() => {
  //   const MIN_SCREEN_WIDTH_FOR_ANIMATION = 768;
  //
  //   const handleResize = () => {
  //     setIsAnimationVisible(window.innerWidth >= MIN_SCREEN_WIDTH_FOR_ANIMATION);
  //     setIsStaticAnimationVisible(window.innerWidth < MIN_SCREEN_WIDTH_FOR_ANIMATION);
  //   };
  //
  //   handleResize();
  //
  //   window.addEventListener("resize", handleResize);
  //   return () => {
  //     window.removeEventListener("resize", handleResize);
  //   };
  // }, []);

  const animationName = useMemo(() => {
    if (isIpv4Country) return `Country_${themePrefix}`;

    const names = {
      [PROXY_TYPES.ipv4.code]: `IPv4_${themePrefix}`,
      [PROXY_TYPES.ipv6.code]: `IPv6_${themePrefix}`,
      [PROXY_TYPES.isp.code]: `ISP_${themePrefix}`,
      [PROXY_TYPES.mobile.code]: `Mobile_${themePrefix}`
    };

    return names[activeData.proxy.code] || `IPv4_${themePrefix}`;
    // eslint-disable-next-line
  }, [activeData, isThemeDark, isIpv4Country]);

  return (
    <div>
      <div className={`index__static-animation index__static-animation--${animationName} media__max-width-992`}>
        <img
          fetchPriority="high"
          src={`/img/static-animation/${animationName}.${animationName === "Mobile_dark" ? "png" : "svg"}`}
          alt={`${animationName} animation`}
        />
      </div>
      <div className="index__animation-container media__min-width-993">
        <div className={`index__animation index__animation--${animationName}`}>
          {/*<Suspense fallback={<></>}>*/}
            <Animation key={animationName} animationName={animationName}/>
          {/*</Suspense>*/}
        </div>
      </div>
    </div>
  );
};
